export default __webpack_public_path__ + "static/media/deri-busd.72878fa9.svg";